import type { EducationCredential } from '../types/content';

export const educationCredential: EducationCredential = {
  qualification: 'Business Administration & Management',
  institution: 'The Open University'
};

export const governanceExposure: string[] = [
  'Board-level reporting and executive committee engagement',
  'European institution and stakeholder engagement',
  'Corporate governance compliance across multi-jurisdictional operations'
];
